'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');
const button_types = require('./button.types.js');

var Label = styled__default.span.withConfig({
  displayName: "buttonstyle__Label",
  componentId: "sc-vlv7w5-0"
})(["display:inline-block;"]);
var StyledButton = styled__default.button.withConfig({
  displayName: "buttonstyle__StyledButton",
  componentId: "sc-vlv7w5-1"
})(["height:", "px;padding-left:", "px;padding-right:", "px;font-size:", "px;", " border-radius:", ";font-weight:bold;vertical-align:bottom;", " ", " ", " svg{padding-top:", "px;vertical-align:top;fill:", ";path{fill:", ";}}", "{", " ", " font-family:", ";}&:hover{", " ", " ", "}", " ", ""], function (_ref) {
  var sizeStyles = _ref.sizeStyles;
  return sizeStyles['height'];
}, function (_ref2) {
  var sizeStyles = _ref2.sizeStyles;
  return sizeStyles['horizontalPadding'];
}, function (_ref3) {
  var sizeStyles = _ref3.sizeStyles;
  return sizeStyles['horizontalPadding'];
}, function (_ref4) {
  var sizeStyles = _ref4.sizeStyles;
  return sizeStyles['fontSize'];
}, function (_ref5) {
  var hasHover = _ref5.hasHover,
    hSpeed = _ref5.hSpeed;
  return hasHover ? "transition: ".concat(hSpeed, "s };") : '';
}, function (_ref6) {
  var shape = _ref6.shape,
    sizeStyles = _ref6.sizeStyles;
  return shape === button_types.ButtonShapes.TAB ? '0px' : [button_types.ButtonShapes.PILL, button_types.ButtonShapes.PILL_SOLID].includes(shape) ? "".concat(sizeStyles['height'] / 2, "px") : '5px';
}, function (_ref7) {
  var backgroundColor = _ref7.backgroundColor,
    active = _ref7.active,
    hoverBackgroundColor = _ref7.hoverBackgroundColor;
  var color = active && hoverBackgroundColor ? hoverBackgroundColor : backgroundColor;
  return color ? "background-color: ".concat(color, ";") : '';
}, function (_ref8) {
  var borderless = _ref8.borderless,
    borderColor = _ref8.borderColor,
    onlyIcon = _ref8.onlyIcon,
    active = _ref8.active,
    hoverBorderColor = _ref8.hoverBorderColor;
  var color = active && hoverBorderColor ? hoverBorderColor : borderColor;
  return !borderless && color && !(button_types.ButtonShapes.PILL && onlyIcon) ? "border: 1px solid ".concat(color, ";") : "border: none;";
}, function (_ref9) {
  var color = _ref9.color,
    active = _ref9.active,
    hoverColor = _ref9.hoverColor;
  var btnColor = active && hoverColor ? hoverColor : color;
  return btnColor ? "color: ".concat(btnColor, ";") : '';
}, function (_ref10) {
  var sizeStyles = _ref10.sizeStyles;
  return sizeStyles['iconPaddingTop'];
}, function (_ref11) {
  var iconColor = _ref11.iconColor,
    color = _ref11.color;
  return iconColor || color;
}, function (_ref12) {
  var iconColor = _ref12.iconColor,
    color = _ref12.color;
  return iconColor || color;
}, Label, function (_ref13) {
  var icon = _ref13.icon,
    onlyIcon = _ref13.onlyIcon,
    iconLeft = _ref13.iconLeft;
  return icon && iconLeft && !onlyIcon ? 'margin-left: 5px;' : '';
}, function (_ref14) {
  var icon = _ref14.icon,
    onlyIcon = _ref14.onlyIcon,
    iconLeft = _ref14.iconLeft;
  return icon && !iconLeft && !onlyIcon ? 'margin-right: 5px;' : '';
}, function (_ref15) {
  var _theme$fonts;
  var _ref15$theme = _ref15.theme,
    theme = _ref15$theme === void 0 ? {} : _ref15$theme;
  return (_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 || (_theme$fonts = _theme$fonts.family) === null || _theme$fonts === void 0 ? void 0 : _theme$fonts.primary;
}, function (_ref16) {
  var disabled = _ref16.disabled;
  return !disabled ? 'cursor: pointer;' : '';
}, function (_ref17) {
  var shape = _ref17.shape,
    theme = _ref17.theme;
  return shape === button_types.ButtonShapes.TAB ? "border-bottom: 3px solid ".concat(theme.primaryLinkHoverColor) : '';
}, function (_ref18) {
  var hasHover = _ref18.hasHover,
    hoverBackgroundColor = _ref18.hoverBackgroundColor,
    hoverColor = _ref18.hoverColor,
    borderless = _ref18.borderless,
    hoverBorderColor = _ref18.hoverBorderColor,
    iconHoverColor = _ref18.iconHoverColor,
    iconColor = _ref18.iconColor,
    color = _ref18.color;
  return hasHover ? "\n      ".concat(hoverBackgroundColor ? "background-color: ".concat(hoverBackgroundColor, ";") : '', "\n      ").concat(hoverColor ? "color: ".concat(hoverColor, ";") : '', "\n      ").concat(!borderless && hoverBorderColor ? "border: 1px solid ".concat(hoverBorderColor, ";") : '', "\n      svg {\n        fill: ").concat(iconHoverColor || iconColor || color, ";\n        path {\n          fill: ").concat(iconHoverColor || iconColor || color, ";\n        }\n      }\n      ") : '';
}, function (_ref19) {
  var shape = _ref19.shape,
    theme = _ref19.theme;
  return shape === button_types.ButtonShapes.TAB ? "\n    background: transparent;\n    border: 0;\n    border-bottom: 3px solid ".concat(universal_color.transparent, ";\n    color: ").concat(theme.disabledLinkColor, ";\n    margin-right: 5px;\n    margin-top: 6px;\n    padding: 6px 12px;\n    position: relative;\n  ") : '';
}, function (_ref20) {
  var styleName = _ref20.styleName,
    theme = _ref20.theme;
  return styleName === button_types.ButtonStyles.SELECTED_TAB ? "\n    color: ".concat(theme === null || theme === void 0 ? void 0 : theme.primaryTextColor, ";\n    border-bottom: 3px solid ").concat(theme.primaryLinkColor, ";\n  ") : '';
});

exports.Label = Label;
exports.StyledButton = StyledButton;
